// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/TreatmentPlans/Content/TreatmentPlan/mutation-set-interval-to-next.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_TreatmentCard_Content_TreatmentPlans_Steps_Content_TreatmentPlans_Content_TreatmentPlan($id: numeric!, $interval_to_next: Int!) {
  update_vaxiom_tx_plan_appointments_by_pk(
    pk_columns: { id: $id }
    _set: { interval_to_next: $interval_to_next }
  ) {
    id
    interval_to_next
  }
}

`